export default __webpack_public_path__ + "static/media/feel.5d558e64.m4a";